<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>
<section class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="form-wrapper">
          @if (!resetLinkSent) {
            <div class="form-wrapper__header">
              <h2 data-translation-key="forget_password_please_enter_your_email">
                {{ "forget_password.please_enter_your_email" | translate }}
              </h2>
            </div>
          }

          @if (!resetLinkSent) {
            <div class="forgot-password-info">
              <p data-translation-key="forget_password_forget_password_note">
                {{ "forget_password.forget_password_note" | translate }}
              </p>
            </div>
          }

          @if (resetLinkSent) {
            <div class="success-message">
              <i class="bi bi-check-circle-fill success-icon"></i>
              <h4
                class="success-title"
                data-translation-key="forget_password_email_sent"
                >
                {{ "forget_password.email_sent" | translate }}
              </h4>
              <p>
                <span
                  data-translation-key="forget_password_password_reset_link_sent"
                  >{{ "forget_password.password_reset_link_sent" | translate }}
                </span>
                <span
                  ><strong>{{ userEmail }}</strong></span
                  >
                  <span
                    data-translation-key="forget_password_password_reset_link_note"
                    >{{
                    "forget_password.password_reset_link_note" | translate
                    }}</span
                    >
                  </p>
                  <p class="help-text">
                    <span
                      data-translation-key="forget_password_password_reset_spam_check"
                      >{{
                      "forget_password.password_reset_spam_check" | translate
                      }}</span
                      >
                      <a
                        href="javascript:void(0)"
                        (click)="resetLinkSent = false"
                        data-translation-key="forget_password_try_again"
                        >{{ "forget_password.try_again" | translate }}</a
                        >
                      </p>
                    </div>
                  }

                  @if (!resetLinkSent) {
                    <form
                      [formGroup]="formData"
                      (ngSubmit)="onSubmit()"
                      >
                      <div class="input-container">
                        <input
                          #emailInput
                          type="email"
                          class="input-field"
                          formControlName="email"
                          [placeholder]="'forget_password.email' | translate"
                [ngClass]="{
                  'is-invalid':
                    formData.get('email')?.touched &&
                    formData.get('email')?.invalid
                }"
                          data-translation-key="forget_password_email"
                          />
                          @if (
                            formData.get('email')?.touched &&
                            formData.get('email')?.invalid
                            ) {
                            <div
                              class="input-feedback error"
                              >
                              @if (formData.get('email')?.hasError('required')) {
                                <div
                                  data-translation-key="forget_password_email_required"
                                  >
                                  {{ "forget_password.email_required" | translate }}
                                </div>
                              }
                              @if (formData.get('email')?.hasError('invalidEmail')) {
                                <div
                                  data-translation-key="forget_password_email_invalid"
                                  >
                                  {{ "forget_password.email_invalid" | translate }}
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <div class="form-buttons">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            (click)="back()"
                            data-translation-key="forget_password_back"
                            >
                            {{ "forget_password.back" | translate }}
                          </button>
                          <button
                            type="submit"
                            class="btn btn-primary"
                            [disabled]="formData.invalid || isLoading"
                            data-translation-key="forget_password_confirm"
                            >
                            @if (isLoading) {
                              <span class="spinner"></span>
                            }
                            {{
                            isLoading
                            ? ("forget_password.sending" | translate)
                            : ("forget_password.confirm" | translate)
                            }}
                          </button>
                        </div>
                      </form>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
